import moment from "moment";
import { prolongDate } from "../../../../../helpers/data-constants";

const useCreditonGlobalProlongDeal = ({
  prolongCalculate = {},
  deals = {},
  startDate,
  isExtensionThreeImplementaition
}) => {
  const newProlongDate = isExtensionThreeImplementaition ? prolongDate.crediton.NEW_PROLONG_DATE : prolongDate.visem.NEW_PROLONG_DATE
  const isNewGlobalProlong = moment(startDate || prolongCalculate[0]?.startDate || deals[0]?.startDate).isAfter(newProlongDate);

  const getInitialDateDefaults = (fieldPosition) => {
    const { maxPaidDate, lastPaidDate, startDate } = { ...fieldPosition }
    const date = lastPaidDate
      ? moment(lastPaidDate).add(1, "days")
      : startDate;
    const maxDate = moment(maxPaidDate).isAfter(moment().add(30, "days"))
      ? moment().add(30, "days")
      : moment(maxPaidDate);

    const minDateDefault = moment(date).format("YYYY-MM-DD");
    const maxDateDefault = maxDate.format("YYYY-MM-DD");
    return { minDateDefault, maxDateDefault };
  };

  const calculateDateDefault = ({ idx, ...params }) => handleDaysLimit(params);

  const handleDaysLimit = ({ fieldPosition }) => {
    const { minDateDefault, maxDateDefault } = getInitialDateDefaults(fieldPosition);

    return {
      minDateDefault,
      maxDateDefault,
      modalExtensionError: {},
    };
  };

  return { calculateDateDefault, isNewGlobalProlong };
};

export default useCreditonGlobalProlongDeal;
